<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="soccer" alt="soccer ball" src="../../assets/images/21a-lrn-spt-cat-4-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>Your inquiry has been sent!<br />
        Thank you for your interest in Lerner Sports!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'ContactUsAcknowledge',

    components: {
      Acknowledge,
    },

    data: function () {
      return {
        headline: 'Gooooaaaallll!',
      }
    }
  };
</script>